import React, { useState } from 'react';
import { Box, useMediaQuery, Drawer } from '@mui/material';
import Header from './Header';
import Sidebar from './Sidebar';
import RoutesConfig from '../routes/RoutesConfig';

const drawerWidth = 240;

const MainLayout: React.FC = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const isTabletOrMobile = useMediaQuery((theme: any) => theme.breakpoints.down('lg')); // Now captures iPads in landscape

  return (
    <Box sx={{ display: 'flex' }}>
      <Header isSidebarOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen} />
      
      {isTabletOrMobile ? (
        <Drawer
          anchor="left"
          open={isSidebarOpen}
          onClose={() => setSidebarOpen(false)}
          sx={{
            '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' },
          }}
        >
          <Sidebar isOpen={isSidebarOpen} setIsOpen={setSidebarOpen} drawerWidth={drawerWidth} />
        </Drawer>
      ) : (
        <Sidebar isOpen={isSidebarOpen} setIsOpen={setSidebarOpen} drawerWidth={drawerWidth} />
      )}

      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: '64px' }}>
        <RoutesConfig />
      </Box>
    </Box>
  );
};

export default MainLayout;
